import { ValueIcon } from '@radix-ui/react-icons'
import { cn } from '@/lib/utils'
import React from 'react'

// Helper function to format price and area
const formatValue = (value, type = "number") => {
  if (value == null) return "k.A.";

  // Return raw value for 'number' type (like build year)
  if (type === "number") return value;

  const formatter = new Intl.NumberFormat('de-DE', {
    style: type === "currency" ? "currency" : undefined,
    currency: "EUR",
    maximumFractionDigits: type === "area" ? 2 : 0,
  });

  return type === "area" ? `${formatter.format(value)} m²` : formatter.format(value);
};

export default function InfoIcon({ price, living, property, rooms, vermietbare_flaeche, baujahr, icon, base_rent, className }) {
  // Data array for easier mapping and conditional rendering
  const infoData = [
    { label: "Preis", value: price, icon: "/Preis.svg", format: "currency" },
    { label: "Kaltmiete", value: base_rent, icon: "/Preis.svg", format: "currency" },
    { label: "Wohnfläche", value: living, icon: "/Wohnflache.svg", format: "area" },
    { label: "Grundstück", value: property, icon: "/Grundstuck.svg", format: "area" },
    { label: "Baujahr", value: baujahr, icon: "/Baujahr.svg", format: "number" },  // Year should not be formatted
    { label: "Zimmer", value: rooms, icon: "/Zimmer.svg", format: "number" },
    { label: "Vermietbare Fläche", value: vermietbare_flaeche, icon: "/Vermietbare.svg", format: "area" },
  ];

  return (
    <div className={cn('grid grid-cols-2 lg:grid-cols-3 justify-between gap-5 py-5 px-4 items-center w-full', className)}>
      {infoData
        .filter(item => item.value != null)  // Filter out null/undefined values
        .map((item, index) => (
          <div key={index} className='flex items-center space-x-3 w-[calc(33%-1rem)] min-w-[200px] md:min-w-[200px] max-w-xs'>
            <div className='md:h-10 md:w-10 size-7 flex items-center justify-center  rounded-full'>
              <img src={item.icon} alt="" />
            </div>
            <div>
              <div className='font-medium md:text-lg'>{formatValue(item.value, item.format)}</div>
              <div className='text-sm text-gray-600 -translate-y-1'>{item.label}</div>
            </div>
          </div>
      ))}
    </div>
  );
}